import { VolumeDiscountUserRepository } from 'public/repository/volume-discount-user.repository';
import { VolumeDiscountRepository } from 'public/repository/volume-discount.repository';
import { migrate } from 'public/utils/migrate';
import {
    getTrialEndTimestamp,
    getTrialStartTimestamp,
} from 'public/utils/trial';
import { ProductView } from 'public/view/product/product.view';
import { getCatalogVersion } from 'backend/catalog-version'
import wixApplication from 'wix-application';
import wixLocationFrontend from 'wix-location-frontend';
import { getConfiguration } from 'public/utils/configuration';

$w('#upgrade-text').hide();
$w('#volumeDiscountsBlock').hide();

const app = {
    configuration: getConfiguration(),
    settings: {
        namespace: getConfiguration().namespace,
        isPaid: false,
        isEditorMode: false,
        productId: null,
    },
    view: null,
};

$w.onReady(async function () {
    console.log("initializing app", app);
    console.log(`${app.configuration.widgetConsoleName}:Widget:initializing`, "VERSION-31");

    $w('#upgrade-text').hide();
    $w('#volumeDiscountsBlock').hide();

    try {
        app.settings.isPaid = await isApplicationPaid({
            namespace: app.settings.namespace,
        });

        app.settings.isEditorMode = isEditorMode();

        if (!app.settings.isEditorMode) {
            $w('#publish-promotion').delete();
        }

        const isV1Catalog = await getCatalogVersion()
        console.log("widget app version", isV1Catalog);

        if (app.configuration.isPlanUpgradeDisabled === true || app.configuration.isTrialDurationHidden === true) {
            $w('#upgrade-text').delete();
            $w('#trial-info').delete();
        } else {
            console.log(`${app.configuration.widgetConsoleName}:Widget:settings`, app.settings);

            if (!app.settings.isPaid) {
                console.log(`${app.configuration.widgetConsoleName}:Widget:setup:settings:isPaid`, app.settings.isPaid);

                $w('#volumeDiscountsBlock').delete();
                $w('#upgrade-text').show();

                if (!app.settings.isEditorMode) {
                    $w('#trial-info').delete();
                }

                return;
            }

            $w('#trial-info').delete();
        }

        app.view = new ProductView({
            settings: app.settings,
            isV1Catalog
        });

        if (app.settings.productId) {
            await app.view.setup();
            $w('#volumeDiscountsBlock').show();
            app.view.render();
        }

        console.log(`${app.configuration.widgetConsoleName}:Widget:loaded`);
    } catch (e) {
        console.error(`${app.configuration.widgetConsoleName}:Widget:error`, e);
        $w('#volumeDiscountsBlock').delete();
    }
});

// For Velo API Reference documentation visit https://www.wix.com/velo/reference/api-overview
// To learn about widget code visit https://support.wix.com/en/article/wix-blocks-coding-in-blocks
/**
 * Add "productId" property to Widget API
 */
$widget.onPropsChanged(async (oldProps, newProps) => {
    console.log(`${getConfiguration().widgetConsoleName}:Widget:onPropsChanged`, { oldProps, newProps });

    if (newProps.productId) {
        app.settings.productId = newProps.productId;

        console.log(`${app.configuration.widgetConsoleName}:Widget:onPropsChanged:settings`, app.settings);

        if (!app.settings.isEditorMode) {
            $w('#trial-info').delete();
            $w('#publish-promotion').delete();
        }

        if (app.view) {
            try {
                app.view.setSettings(app.settings);
                await app.view.setup();
                $w('#volumeDiscountsBlock').show();
                app.view.render();
            } catch (e) {
                console.error(`${getConfiguration().widgetConsoleName}:Widget:onPropsChanged:error`, e);
                $w('#volumeDiscountsBlock').delete();
                $w('#trial-info').delete();
            }
        }
    }
});

/**
 * @param {Object} settings
 * @param {string} settings.namespace
 * @returns {Promise<boolean>}
 */
async function isApplicationPaid(settings) {
    const appInstance = await wixApplication.getDecodedAppInstance();

    const volumeDiscountUserRepository = new VolumeDiscountUserRepository(
        settings,
    );

    const volumeDiscountRepository = new VolumeDiscountRepository(settings);

    if (isUpgraded(appInstance)) {
        return true;
    }

    const startTimestamp = await getTrialStartTimestamp({
        volumeDiscountRepository,
        volumeDiscountUserRepository,
    });

    const trial = getTrialEndTimestamp(startTimestamp);

    if (!trial.isActive) {
        return false;
    }

    return true;
}

/**
 * @param {Object} appInstance
 * @param {string} appInstance.vendorProductId
 * @returns {boolean}
 */
function isUpgraded(appInstance) {
    return !!appInstance.vendorProductId;
}

/**
 * @returns {boolean}
 */
function isEditorMode() {
    const domains = ['editor.wix', 'blocks.wix'];

    return domains.some((domain) => wixLocationFrontend.baseUrl.includes(domain));
}